import { Toast } from 'antd-mobile';
// import { localStorageHelper } from 'tools/StorageHelper';
import handleResponseCode from './ResponseCodeHandle';
import { getCookie } from 'tools/utils/libs/cookie';

// const project = process.env.NODE_ENV === 'production' ? '' : '/phenix';
// 处理btn状态的事件
const evt = document.createEvent('Event');
evt.initEvent('setBtnEnabled', true, true);

function parseJSON(response) {
    if (response) {
        return response.json();
    } else {
        // 404,500等服务器错误状态
        return { code: 100, data: {} };
    }
}
const stringifyParams = params => (
    Object.keys(params).map((key) => {
        if (typeof params[key] === 'object') {
            return `${key}=${encodeURIComponent(JSON.stringify(params[key]))}`;
        } else {
            return `${key}=${encodeURIComponent(params[key])}`;
        }
    }).join('&')
);

function checkStatus(response, hasLoading) {
    if (response.status >= 200 && response.status < 300) {
        // 请求处理完成关闭loading，错误的结果会有错误的提示
        hasLoading && Toast.hide();
        return response;
    } else if (response.status === 504) {
        Toast.offline('请求超时，请稍后再试');
    } else {
        // 服务器访问错误
        Toast.offline(`请求处理异常[错误码:'${response.status}]`);
    }
    if (process.env.NODE_ENV === 'development') {
        const error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}

function handleData(data) {
    // 过滤条件
    // 保证结果格式一致
    if (!data.data) {
        Object.assign(data, { data: {} });
    }
    if (data.code !== 0) {
        try {
            // setBtnEnabled
            document.body.dispatchEvent(evt);
        } catch (e) {
            console.log('Request.js Line 57:', e);
        }
        return handleResponseCode(data);
    }
    return data;
}

// 去除get请求参数末尾带着的&
function formatGetReqParams(params) {
    if (params === '?') return '';
    const arr = params.split('');
    return arr.pop(1) === '&' ? arr.join('') : params;
}
// 所有请求加前缀(2018-11-12 yangfei03)
// 需要更改所有的已有请求，先这么设置一下吧!!
const reqUrlPrefix = '/consumeloan';
const commonReqHeader = {
    'cache-control': 'no-cache',
    'X-Requested-With': 'Fetch',
    'referer-url': window.location.href,
    Accept: 'application/json',
};
/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default {
    get: (url, options = {}) => {
        // alert(navigator.onLine);
        // if (!navigator.onLine) {
        //     return getCacheData(url);
        // }
        let _params = '?';
        let hasLoading = false;
        // 请求数据加载动画的标识
        if (Object.prototype.hasOwnProperty.call(options, 'LOADTEXT')) {
            const loadText = options.LOADTEXT ? options.LOADTEXT : '加载中...';
            Toast.loading(loadText, 0);
            hasLoading = true;
            Object.assign(options, { LOADTEXT: undefined });
        }
        for (const key in options) {
            if (Object.prototype.hasOwnProperty.call(options, key) && typeof options[key] !== 'undefined') { // 这么写是因为有时候参数的值为0 会被过滤掉
                _params += `${key}=${options[key]}&`;
            }
        }
        // 参数最后末尾会多一个& 处理一下去掉
        return fetch(`${reqUrlPrefix}${url}${formatGetReqParams(_params)}`, {
            method: 'get',
            headers: {
                ...commonReqHeader,
                'Content-Type': 'application/json; charset=utf-8',
            },
            credentials: 'include',
        })
            .then(response => checkStatus(response, hasLoading))
            .then(parseJSON)
            .then(data => handleData(data))
            .catch((err) => {
                if (err.message === 'Failed to fetch') {
                    // 网络异常
                    Toast.offline('网络连接失败!');
                } else {
                    // 请求处理异常
                    Toast.offline('请求处理异常!');
                }
                throw err;
            });
    },
    post(url, options = {}, isUploadFile) {
        let _params = {};
        let hasLoading = false;
        // 请求数据加载动画的标识
        if (Object.prototype.hasOwnProperty.call(options, 'LOADTEXT')) {
            Toast.loading(options.LOADTEXT ? options.LOADTEXT : '加载中...', 0);
            hasLoading = true;
            Object.assign(options, { LOADTEXT: undefined });
        }
        if (!isUploadFile) {
            for (const key in options) {
                if (typeof options[key] !== 'undefined') { // 这么写是因为有时候参数的值为0 会被过滤掉
                    _params[key] = options[key];
                }
            }
        } else {
            _params = options;
        }
        return fetch(`${reqUrlPrefix}${url}`, {
            method: 'post',
            headers: isUploadFile ? {} : {
                ...commonReqHeader,
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-csrf-token': getCookie('PPU') || '',
            },
            credentials: 'include',
            body: isUploadFile ? _params : stringifyParams(_params),
        })
            .then(response => checkStatus(response, hasLoading))
            .then(parseJSON)
            .then(handleData)
            .catch((err) => {
                // setBtnEnabled
                document.body.dispatchEvent(evt);
                if (err.message === 'Failed to fetch') {
                    // 网络异常
                    Toast.offline('网络连接失败!');
                } else {
                    // 请求处理异常
                    Toast.offline('请求处理异常!');
                }
                throw err;
            });
    },
};

// 无网显示首页
// function getCacheData(url) {
//     if (url.indexOf('/apply/status') !== -1 || url.indexOf('/apply/approveInfo') !== -1 || url.indexOf('/withdraw/p2p/status') !== -1) {
//         return new Promise((resolve) => {
//             resolve(JSON.parse(localStorageHelper.getItem(url)));
//         });
//     }
// }

// function setCacheData(url, data) {
//     if (url.indexOf('/apply/status') !== -1 || url.indexOf('/apply/approveInfo') !== -1 || url.indexOf('/withdraw/p2p/status') !== -1) {
//         localStorageHelper.setItem(url, data);
//     }
// }



// WEBPACK FOOTER //
// ./src/api/Request.js